export default __webpack_public_path__ + "assets/images/Check-e46479ed63f6e8f594959ee46700dd62.svg";